import { AfterViewInit, ChangeDetectorRef, Directive, ElementRef, OnInit } from '@angular/core';

@Directive({
    selector: '[dianaAutoFocus]',
    standalone: false
})
export class AutoFocusDirective implements AfterViewInit {

  constructor(
    private el: ElementRef,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngAfterViewInit() {
    this.el.nativeElement.focus();
    this.changeDetectorRef.detectChanges();
  }

}
